import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { SummaryMain, SummaryItemMain, SummaryItemLabel } from './css';

/**
 * Summary-tracker card(s) for the products a rep completed through an
 * `IoTPopupButton`. Mirrors `AccessoriesTracker`: products are grouped by their
 * source table title and each group renders a heading followed by a
 * name/quantity list.
 */
const IotPopupTracker = ({ products }) => {
  const list = Array.isArray(products) ? products : [];
  if (list.length === 0) return null;

  const groups = Object.entries(
    list.reduce((acc, product) => {
      const groupName =
        _.get(product, 'sourceTableTitle', '') ||
        _.get(product, 'sourceTable', '') ||
        _.get(product, 'rateplanType', '');
      if (!acc[groupName]) acc[groupName] = [];
      acc[groupName].push(product);
      return acc;
    }, {})
  );

  return (
    <>
      {groups.map(([groupName, groupProducts]) => (
        <div key={groupName || 'ungrouped'}>
          <h4>{groupName}</h4>
          <SummaryMain>
            {groupProducts.map(product => (
              <SummaryItemMain key={product.key}>
                <SummaryItemLabel>
                  {_.get(product, 'label', '')}
                </SummaryItemLabel>
                <span>{_.get(product, 'quantity', 0)}</span>
              </SummaryItemMain>
            ))}
          </SummaryMain>
        </div>
      ))}
    </>
  );
};

IotPopupTracker.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({}))
};

IotPopupTracker.defaultProps = {
  products: []
};

export default IotPopupTracker;
